import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Contract } from "../../../model/contract";

@Component({
  selector: 'aw-create-contract',
  templateUrl: './create-contract-dialog.component.html',
  styleUrls: ['./create-contract-dialog.component.scss']
})
export class CreateContractDialogComponent implements OnInit {


  constructor(
    @Inject(MAT_DIALOG_DATA) public data: Contract,
    public dialogRef: MatDialogRef<CreateContractDialogComponent>,
  ) {


  }

  ngOnInit(): void {
  }


}


